import React from 'react';

import {
  ChevronsUpDown,
  Info,
  Moon,
  Monitor,
  Sun,
  Package,
  ClipboardList,
  CheckSquare,
  LineChart,
  LogOut,
  Layers,
  Search,
  Plus,
  ShoppingBag,
  Menu,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  User,
  MapPin,
  X,
  Clock,
  CreditCard,
  ArrowLeft,
  DollarSign,
  Check,
  HelpCircle,
  AlertTriangle,
  ArrowRight,
  Minus,
  Bell,
  Home,
  Users,
  FileBarChart,
  Ticket,
  LayoutList,
  Backpack,
  Edit,
  Edit2,
  Landmark,
  Trash2,
  AlertOctagon,
  ArrowUp,
  ShoppingCart,
  AlertCircle,
  Grid,
  List,
  MoreHorizontal,
  FileText,
  RefreshCw,
  ExternalLink,
  Crop,
  Sprout,
  ChevronsLeft,
  ChevronsRight,
} from '@tamagui/lucide-icons';

export const iconComponents = {
  sun: Sun,
  moon: Moon,
  monitor: Monitor,
  chevronsUpDown: ChevronsUpDown,
  crop: Crop,
  sprout: Sprout,
  package: Package,
  alertTriangle: AlertTriangle,
  checkSquare: CheckSquare,
  search: Search,
  grid: Grid,
  list: List,
  lineChart: LineChart,
  layers: Layers,
  plus: Plus,
  info: Info,
  shoppingBag: ShoppingBag,
  shoppingCart: ShoppingCart,
  menu: Menu,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  chevronsLeft: ChevronsLeft,
  chevronsRight: ChevronsRight,
  user: User,
  mapPin: MapPin,
  close: X,
  clock: Clock,
  creditCard: CreditCard,
  arrowLeft: ArrowLeft,
  dollarSign: DollarSign,
  check: Check,
  help: HelpCircle,
  minus: Minus,
  arrowRight: ArrowRight,
  bell: Bell,
  house: Home,
  users: Users,
  chartDocument: FileBarChart,
  ticket: Ticket,
  layoutList: LayoutList,
  backpack: Backpack,
  landmark: Landmark,
  pen: Edit2,
  edit: Edit,
  trash: Trash2,
  alert: AlertOctagon,
  alertCircle: AlertCircle,
  arrowUp: ArrowUp,
  clipboardList: ClipboardList,
  logOut: LogOut,
  moreHorizontal: MoreHorizontal,
  fileText: FileText,
  refreshCw: RefreshCw,
  externalLink: ExternalLink,
};

export type IconName = keyof typeof iconComponents;

export type Props = {
  icon: IconName;
  color?: string;
  size?: number;
};

const Icon = ({ icon, color = '$contrast', size = 24 }: Props) => {
  const C = iconComponents[icon];

  if (!C) {
    throw new Error(`Could not find icon: ${icon}`);
  }

  return <C color={color} size={size} />;
};

export default Icon;
